import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import { Container } from '@stackhouse/styled-elements'

import { withDashboardContext } from '@stackhouse/dashboard-components/Dashboard'

import FiltersBox from '../components/FiltersBox'

import { getFormValueMap } from '../utils/form'


const filtersConfigEndpoint = functionName => `/settings/FiltersConfig/${functionName}`


class ReportFilterTemplate extends PureComponent {

    constructor(props) {
        super(props)
        this.searchBoxRef = React.createRef()
        this.state = { fields: [], openSections: [] }
    }

    static propTypes = {
        functionName: PropTypes.string,
        fields: PropTypes.object,
        filters: PropTypes.array
    }


    componentDidMount() {
        const { withLoader } = this.props
        return withLoader(this.loadData)
    }

    loadData = (callback) => {
        const { client, fields, filters, functionName } = this.props

        const _fields = fields ? fields instanceof Function ? fields() : fields : functionName ? client.get(filtersConfigEndpoint(functionName)).then(res => res.data) : {}
        const _filters = filters ? filters instanceof Function ? filters() : filters : []

        return Promise.all([_fields, _filters]).then(([{ filterBoxList, openSection }, filters]) => {
            return this.setState({ fields: filterBoxList, openSections: openSection, filters })
        }).then(callback).catch(callback)
    }

    getFilter = () => {
        const { fields } = this.state
        const { query, filter, barcodeSearch } = this.searchBoxRef.current.getFilter()

        return {
            barcodeSearch,
            singleTextSearch: query,
            filterBoxList: getFormValueMap(fields, filter)
        }
    }

    render() {
        const { fields, openSections, filters } = this.state
        return (
            <Container flex={0}>
                <FiltersBox
                    ref={this.searchBoxRef}
                    fields={fields}
                    openSections={openSections}
                    filters={filters}
                />
            </Container>
        )
    }
}


export default withDashboardContext(ReportFilterTemplate, ({ client, withLoader }) => ({ client, withLoader }))